export default {
  inserted (el, binding) {
    if (!binding.value) {
      return
    }
    const options = {
      rootMargin: binding.value.margin || '100px',
      threshold: binding.value.threshold || 0.1
    }

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          binding.value.onIntersect()
          observer.unobserve(entry.target)
        }
      })
    }

    const observer = new IntersectionObserver(callback, options)
    observer.observe(el)
  }
}
